import React from 'react';
import SiteFeatures from '~/components/partials/homepage/home-default/SiteFeatures';
import FooterWidgets from './modules/FooterWidgets';
import PromoBanner from '~/components/partials/commons/PromoBanner';
// import FooterLinks from './modules/FooterLinks';
import FooterCopyright from './modules/FooterCopyright';

const FooterFullwidth = () => (
    <footer className="ps-footer">
        <div className="ps-container">
            {/* <SiteFeatures /> */}
            <PromoBanner />
            <SiteFeatures />
            <FooterWidgets />
            {/* <FooterLinks /> */}
            <FooterCopyright />
        </div>
    </footer>
);

export default FooterFullwidth;